module.exports = __webpack_public_path__ + "static/media/arrow-right.2fdb1b0b.svg";